<svc-button
  svcTestId="ap-form__btn--approval"
  class="ap-approval-trigger"
  type="button"
  mode="flat"
  color="on-primary"
  [matMenuTriggerFor]="approvalMenu"
  [processing]="processing()"
>
  <span class="ap-approval-label">{{ 'Approval' | transloco }}</span>
  <mat-icon
    class="ap-approval-chevron text-current"
    svgIcon="fontawesome_solid:chevron-down"
  ></mat-icon>
</svc-button>

<mat-menu
  #approvalMenu="matMenu"
  class="ap-approval-dropdown"
  panelClass="ap-approval-dropdown"
  yPosition="below"
  xPosition="after"
>
  <div class="ap-approval-dropdown-content">
    <button
      svcTestId="ap-form__btn--approval-reject"
      type="button"
      class="ap-approval-item ap-approval-item--reject"
      [disabled]="processing()"
      matMenuClose
      (click)="onReject.emit()"
    >
      <mat-icon
        class="ap-approval-item-icon ap-approval-reject-icon"
        svgIcon="fontawesome_solid:xmark"
      ></mat-icon>
      <span class="ap-approval-item-label">{{ 'Rejeitar' | transloco }}</span>
    </button>

    <button
      svcTestId="ap-form__btn--approval-approve"
      type="button"
      class="ap-approval-item ap-approval-item--approve"
      [disabled]="processing()"
      matMenuClose
      (click)="onApprove.emit()"
    >
      <mat-icon
        class="ap-approval-item-icon ap-approval-approve-icon"
        svgIcon="fontawesome_solid:check"
      ></mat-icon>
      <span class="ap-approval-item-label">{{ 'Approve' | transloco }}</span>
    </button>
  </div>
</mat-menu>
